import { useCallback } from 'react';
import { useValidation } from '@eti/providers';
import { Field } from '@eti/form';
import MutuallyExclusive from '../components/MutuallyExclusive';
import { generateMuxProductKey, getEmptyOptionId } from '../utils';
import { mutuallyExclusive } from '../index';
import { useMutuallyExclusiveState } from '../hooks/useMutuallyExclusiveState';
import { jsx as _jsx } from "react/jsx-runtime";
const MutuallyExclusiveFieldWrapper = ({
  numberOfTravelers,
  products
}) => {
  const validate = useValidation(mutuallyExclusive.name);
  const identifierKey = generateMuxProductKey(products);
  const {
    isAnyProductSelectedInBundle,
    selection,
    onChange
  } = useMutuallyExclusiveState(products);
  const handleFieldChange = useCallback(value => {
    onChange(value);
  }, [onChange]);
  return /*#__PURE__*/_jsx(Field, {
    component: MutuallyExclusive,
    emptyOptionId: getEmptyOptionId(identifierKey),
    isAnyProductSelectedInBundle: isAnyProductSelectedInBundle,
    name: `${mutuallyExclusive.name}.${identifierKey}`,
    numberOfTravelers: numberOfTravelers,
    onChange: handleFieldChange,
    products: products,
    selection: selection,
    validate: validate
  });
};
export default MutuallyExclusiveFieldWrapper;
//# sourceMappingURL=MutuallyExclusiveContainer.js.map